const themes = ["theme_blue", "theme_pink"];
export default themes;
